import LoadingIcon from "@common/LoadingIcon";
import { TitleWithDivider } from "@common/TitleWithDivider";
import "react-toastify/dist/ReactToastify.css";
import ChangeDepartmentParentModal from "@components/Modals/ChangeDepartmentParentModal";
import { error_message } from "@constants/Errors";
import { HeaderItems } from "@common/HeaderItems";
import pageHeaders from "@constants/PageHeaders";
import WarningModal from "@components/Modals/WarningModal";
import { DepartmentTree } from "@pages/KAKELY/DepartmentGroupMainPage/components/DepartmentTree";
import { useEditDepartmentGroup } from "@pages/KAKELY/DepartmentGroupMainPage/hooks/useDepartmentGroupMainPage";
import PaginationControls from "@services/PaginationControls";

const DepartmentGroupMainPage: React.FC = () => {
  const form = useEditDepartmentGroup();

  return (
    <div className="container mx-auto px-4 py-6 sm:px-6 lg:px-8">
      <TitleWithDivider
        titleText={pageHeaders.KAKELY.departmentMain}
        useDivider={true}
      />

      <div>
        <HeaderItems
          items={form.headerItems}
          topPadding={5}
          disabled={form.loading}
          useDivider={false}
        ></HeaderItems>
      </div>
      <div className="flex flex-col mt-6 border border-text-field-border rounded-lg bg-white shadow-sm">
        <div className="p-2">
          {form.loadingDownload && (
            <div className="fixed inset-0 flex items-center justify-center backdrop-brightness-50 z-50">
              <div className="bg-white bg-opacity-95 p-5 rounded-lg shadow-lg flex items-center justify-center">
                <LoadingIcon
                  bodyText={
                    "部署の情報ダウンロード中です。しばらくお待ちください。"
                  }
                />
              </div>
            </div>
          )}
          {form.loading ? (
            <div className="flex justify-center items-center min-h-[20vh]">
              <LoadingIcon />
            </div>
          ) : (
            <>
              <div className="flex flex-col">
                <div className="w-full">
                  <div className="p-2">
                    {form.tenantDepartments.length >= 1 ? (
                      <div className="mt-2">
                        <DepartmentTree
                          depts={form.originalTenantDepartments}
                          setSelectedDepartments={form.setSelectedDepartments}
                          expandedNodes={form.expandedNodes}
                          toggleExpand={form.toggleExpand}
                          handleOpenChangeParentModal={
                            form.handleOpenChangeParentModal
                          }
                          handleOpenDeleteModal={form.handleOpenDeleteModal}
                          handleOpenCreatePage={form.handleOpenCreatePage}
                          handleOpenEditPage={form.handleOpenEditPage}
                        />
                      </div>
                    ) : (
                      <div className="mb-5 mt-5 flex text-center justify-center text-lg font-semibold text-gray-700">
                        {error_message.departments.no_departments}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <WarningModal
        title={form.warningModalTitle}
        body={form.warningModalBody}
        confirmText={form.warningModalConfirm}
        isOpen={form.deleteModalOpen}
        onConfirm={form.handleDelete}
        onRequestClose={form.handleCloseDeleteModal}
      />

      <ChangeDepartmentParentModal
        isOpen={form.parentModalOpen}
        nodeId={form.selectedNodeId}
        onRequestClose={form.handleCloseParentModal}
        onSelectGroup={form.handleConfirmParentModal}
      />
      <PaginationControls
        currentPage={form.currentPage}
        totalPages={form.totalPages}
        totalItems={form.totalTenantDepartments}
        displayedItem={"部署"}
        onPageChange={form.handlePageChange}
        setPerPage={form.setItemsPerPage}
        perPage={form.itemsPerPage}
      />
    </div>
  );
};

export default DepartmentGroupMainPage;
